// extracted by mini-css-extract-plugin
export var item = "RuledList-module--item--GXANv";
export var list = "RuledList-module--list--xc+0j";
export var ruleBottom = "RuledList-module--ruleBottom--8Bjv9";
export var ruleTop = "RuledList-module--ruleTop--or5r4";